import axios from "axios";

export const state = {
    papers: [],
};

export const getters = {
    papers: state => state.papers,
};

export const mutations = {
    setPapers(state, newValue) {
        state.papers = newValue
    },
};

export const actions = {
    fetchPapers({ commit }) {
        axios.get('/papers').then(res => {
            commit('setPapers', res.data.papers);
        })
    },
};
